import { render } from "./Program03.vue?vue&type=template&id=42f54f54"
import script from "./Program03.vue?vue&type=script&lang=js"
export * from "./Program03.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__